import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  DetailsCard: {
    padding: 10,
    '&__icon-close': {
      cursor: 'pointer',
    },
    '&__padding-left': {
      paddingLeft: 15,
    },
    '&__header': {
      width: 'calc(100% + 20px)',
      margin: -10,
      padding: 10,
      marginBottom: 20,
    },
    '&__margin-auto': {
      margin: 'auto',
    },
    '&__margin-bottom': {
      marginBottom: 40,
    },
    '&__span-title': {
      color: theme.typography.color.secondary,
      fontSize: '0.7rem',
      fontWeight: 'bold',
    },
    '&__span-value': {
      color: theme.typography.color.primary,
      fontSize: '0.8rem',
    },
    '&__button': {
      width: '90%',
      marginLeft: '5%',
      fontSize: '0.7rem',
      padding: 5,
      marginTop: 0,
      marginBottom: 3,
      '&--accept': {
        backgroundColor: theme.palette.success.main,
      },
      '&--accept:hover': {
        backgroundColor: theme.palette.success.main,
      },
      '&--reject': {
        backgroundColor: theme.palette.error.main,
      },
      '&--reject:hover': {
        backgroundColor: theme.palette.error.main,
      },
    },
  },
}));

export default useStyles;
